import { Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import notFoundImg from "../../assets/images/file-searching.svg";
import { DEFAULT_USER_PAGE_URL } from "constants/menu";

export function ErrorPageNotFound() {
  return (
    <Row className="pt-5 justify-content-md-center">
      <Col xs={12} md={7} xl={5}>
        <Card>
          <Card.Body>
            <div className="pt-sm-5 pb-4 pb-sm-5 text-center">
              <img src={notFoundImg} height="150" alt="" />
              <h1 className="text-error mt-4">404</h1>
              <h4 className="text-uppercase text-danger mt-3">
                Page Not Found
              </h4>
              <p className="text-muted mt-3">
                Oops! The page you are looking for does not exist.
              </p>
              <Row className="justify-content-md-center">
                <Col xs={3}></Col>
                <Col xs={6}>
                  <Link
                    className="btn btn-primary mt-3"
                    to={DEFAULT_USER_PAGE_URL}
                  >
                    Back to home
                  </Link>
                </Col>
                <Col xs={3}></Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
